import { Link } from 'react-router';
import { SEOHead } from '@/components/seo/SEOHead';
import { Clock, Tag, ChevronRight } from 'lucide-react';
import { blogPosts } from '@/data/blogPosts';

export const BlogIndex = () => {
  return (
    <>
      <SEOHead
        title="Blog - PeeTrack Health Guides"
        description="In-depth guides and feature highlights to help you get the most out of PeeTrack's bladder health tracking features."
        keywords={[
          'bladder health blog',
          'pee tracking guide',
          'fluid tracking tips',
          'neo-bladder care',
          'health tracking tutorials',
        ]}
        canonical="/blog"
      />

      {/* Hero Section */}
      <section className="bg-gradient-to-b from-cyan-50 to-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              PeeTrack Blog
            </h1>
            <p className="text-lg md:text-xl text-gray-600">
              In-depth guides and feature highlights to help you get the most out of PeeTrack
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 flex flex-col border border-gray-100"
              >
                {/* Blog post image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.imageAlt}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                  <div className="absolute top-4 right-4">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-cyan-500 text-white shadow-lg">
                      <Tag className="h-3 w-3 mr-1" />
                      {post.category}
                    </span>
                  </div>
                </div>

                {/* Blog post content */}
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-3 text-sm text-gray-500 mb-3">
                    <span>{post.date}</span>
                    <span>•</span>
                    <span className="flex items-center gap-1">
                      <Clock className="h-4 w-4" />
                      {post.readTime}
                    </span>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                    {post.title}
                  </h3>

                  <p className="text-gray-600 mb-4 flex-1 line-clamp-3">
                    {post.excerpt}
                  </p>

                  <Link
                    to={post.slug}
                    className="inline-flex items-center gap-2 text-cyan-600 hover:text-cyan-700 font-semibold group"
                  >
                    Read More
                    <ChevronRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
